<template>
  <div class="l-container confirm-info">
    <div class="top-title ml-2 font-bold">
      <h3>ベネポの確認</h3>
    </div>
    <div class="divider my-3"></div>


    <div class="main-content flex">
      <!-- Sidebar -->
      <div class="left-content ">
        <LeftMenuBar :navBars = "navBars" />
      </div>

      <!-- Two List -->
      <div class="right-content">
        <!-- LIST 1 -->
        <TotalPoint :pointInfo = "pointInfo"/>
        <!-- DETAIL HISTORY POINT BENEPO -->
        <div class="detail-point">
          <a class="text-black" @click="gotoPath(1)">獲得予定ベネポの詳細を見る</a>
          <i class="icon icon-bor-arrow-right text-red-500 flex items-center"/>
        </div>

        <!-- LIST 2 -->
        <div class="list2 c-box">
          <a-tabs>
            <!-- Expiry Date -->
            <a-tab-pane name="expiryDate" tab="有効期限が近いベネポ" key="1">
              <ExpiryDate :title="title"
                @getListPointNearExpDateByDate="getListPointNearExpDateByDate($event)"
               :totalElePointExpiry="totalElePointExpiry"  
               :listData="listPointExpiryDate"/>
            </a-tab-pane>

            <!-- Benepo acquisition / usage history -->
            <a-tab-pane name="history" tab="ベネポ獲得・利用履歴">
              <HistoryUse 
              @onChange1="onChange1($event)" 
              @getListPoint="getListPoint($event)"
              :totalElePointHistory="totalRecordPoint"  
              :listDataHistory="listPointHistory"/>
            </a-tab-pane>
          </a-tabs>
          <div class="pb-6 mt-4 w-full text-center">
            <button @click="gotoPath(2)" class="c-btn bg-gray-200 submit-btn">
              <span class="px-16 font-bold sm:px-8">
                ベネポが使えるメニューを見る
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LeftMenuBar } from '@/components/compound'
import TotalPoint from './TotalPoint'
import ExpiryDate from './ExpiryDate'
import HistoryUse from './HistoryUse'
import { GET_POINT_HISTORY } from '@/store/modules/bs_myp/actions'
import { BREADCRUMBS } from '@/store/modules/app/actions'
import moment from 'moment'
import _ from 'lodash'

export default {
  components: {
    LeftMenuBar,
    TotalPoint,
    ExpiryDate,
    HistoryUse
  },

  data() {
    return {
      breadcrumb_data: ['トップ', 'マイページ', 'ベネポの確認'],
      title: '3カ月以内に無効になるベネポ',
      totalRecordPoint: 0,
      breadcrumbs: [],
      paramPointNearExpDate: {
        commandType: '1,2'
      },
      paramPointHistory: {
        pointFrom: '',
        pointTo: '',
        startIndex: 0,
        count: 10
      },
      pagePointHistory: 0,
      totalElePointExpiry: 0,
      pointInfo: {
        totalPoint: '',
        grantedPoint: '',
        noUseLimitPoint: '',
        useLimitPoint: ''
      },
      listPointExpiryDate: [],
      listPointHistory: [],
      
      listExpiryDate: [
        {
          date: '2021/4/30に無効になるベネポ',
          point: '10P'
        },
        {
          date: '2021/5/12に無効になるベネポ',
          point: '10P'
        },
        {
          date: '2021/5/31に無効になるベネポ',
          point: '10P'
        },
        {
          date: '2021/6/30に無効になるベネポ',
          point: '10P'
        }
      ],
      listDataHistory: [
        {
          id: 1,
          date: '2021/4/30',
          status: 1,
          statusText: '獲得',
          content: '○○キャンペーン申込み',
          point: '+10P'
        },
        {
          id: 2,
          date: '2021/4/30',
          status: 0,
          statusText: '利用',
          content: '○○サービスの利用',
          point: '-10P'
        },
        {
          id: 3,
          date: '2021/4/30',
          status: 0,
          statusText: '利用',
          content: '有効期限切れ',
          point: '-10P'
        },
        {
          id: 4,
          date: '2021/4/30',
          status: 0,
          statusText: '利用',
          content: '○○によって取消',
          point: '-10P'
        },
        {
          id: 5,
          date: '2021/4/30',
          status: 1,
          statusText: '獲得',
          content: 'サービス利用：○○○メニュー',
          point: '+10P'
        },
        {
          id: 6,
          date: '2021/4/30',
          status: 0,
          statusText: '利用',
          content: '○○サービスの利用',
          point: '-10P'
        },
        {
          id: 7,
          date: '2021/4/30',
          status: 0,
          statusText: '利用',
          content: '○○サービスの利用',
          point: '-10P'
        },
        {
          id: 8,
          date: '2021/4/30',
          status: 0,
          statusText: '利用',
          content: '○○サービスの利用',
          point: '-10P'
        }
      ],
      navBars: [
        { path: '/mypage', name: 'マイページトップ' },
        { type: 'divider' },
        { path: '/mypage/benepo-history', name: '総保有ベネポ・ベネポ履歴' },
        { path: '/mypage/benepo-collect', name: '獲得予定のベネポ', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '/mypage/coupons', name: '専用ポイント・補助クーポン' },
        { type: 'divider' },
        { path: 'bs-myp-02-001', name: 'マイクーポン' },
        { path: 'bs-myp-02-010', name: '過去のクーポン' },
        { type: 'divider' },
        { path: '/mypage/orders', name: 'お申し込み履歴' },
        { path: '', name: '給与天引きご利用履歴', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '/mypage/visits', name: '閲覧履歴' },
        { type: 'divider' },
        { path: '/mypage/favorites', name: 'お気に入りメニュー' },
        { type: 'divider' },
        { path: '/mypage/setting', name: '会員プロフィール' },
        { path: '', name: 'メール受信・通知' },
        { path: '', name: 'クレジットカード', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '', name: '家族アカウント管理', icon: 'icon-bor-copy' }
      ]
    }
  },
  mounted() {
    if (this.loggedIn) {
      this.getListPointNearExpDateInThreeMonth(this.paramPointNearExpDate)
      // this.getTotalElePoint()
      const breadcrumbs = [
        { title: 'トップ', path: '/' },
        { title: 'マイページ', path: '/mypage' },
        { title: ' ベネポの確認 ', path: '' }
      ]
      this.$store.dispatch(BREADCRUMBS, breadcrumbs)
    } else {
      const params = {
        loggin: 1
      }
      this.$router.push({path: '/', query: params})
    }
  },
  computed: {
    loggedIn() {
      return this.$auth.loggedIn
    }
  },
  methods: {
    checkValidTimePointInThreeMonths(timeStr) {
      const dateOfPoint = this.formatDatePoint(timeStr)
      const dateFuture = moment().subtract(-3, 'months').format('YYYY/MM/DD')
      const dateCurrent = moment().format('YYYY/MM/DD')
      return moment(dateOfPoint).isBetween(dateCurrent, dateFuture)
    },
    formatDatePoint(timeStr) {
      const yearOfPointHist = timeStr.substr(0, 4)
      const monthOfPointHist = timeStr.substr(4, 2)
      const dayOfPointHist = timeStr.substr(6, 2)
      return `${yearOfPointHist}/${ monthOfPointHist}/${ dayOfPointHist}`  
    },
    getListPoint($event) {
      this.getListPointHistory($event)
    },
    getListPointNearExpDateInThreeMonth(params) {
      this.listPointExpiryDate = []
      this.$store.dispatch(GET_POINT_HISTORY, params).then((data) => {
        if(data) {
          this.totalElePointExpiry = 0
          this.pointInfo.totalPoint = _.get(data, 'totalPoint', null)
          this.pointInfo.grantedPoint =  _.get(data, 'grantedPoint', null)
          this.pointInfo.noUseLimitPoint = _.get(data, 'noUseLimitPoint', null)
          this.pointInfo.useLimitPoint = _.get(data, 'useLimitPoint', null)
          if(data && data.historyDataList) {
            this.getListPointHistory(this.paramPointHistory)
            data.historyDataList.filter(item => this.checkValidTimePointInThreeMonths(item.validTo)).forEach(ele => {    
              const pointExpiryDate = {}
              pointExpiryDate.point = _.get(ele, 'point', '')
              pointExpiryDate.reasonInternal = _.get(ele, 'reasonInternal', '')
              pointExpiryDate.validTo = this.formatDatePoint(_.get(ele, 'validTo', ''))
              if(pointExpiryDate.point >= 1) {
                this.totalElePointExpiry += 1
                this.listPointExpiryDate.push(pointExpiryDate)
              }
            })
          }
        }
      })
    },
    getListPointHistory(params) {
      this.totalRecordPoint = 0
      params.startIndex = params.startIndex - 1
      if (params.startIndex === -1) {
        params.startIndex = 0
      }
      this.listPointHistory = []
      this.$store.dispatch(GET_POINT_HISTORY, params).then((data) => {
        if(data && data.historyDataList) {
          this.totalRecordPoint = _.get(data, 'historyDataList', '').length
          data.historyDataList.forEach(content => {
            const pointHistory = {}
            pointHistory.point = _.get(content, 'point', '')
            pointHistory.content = _.get(content, 'reasonCustomer', '')
            const statusPoint = _.get(content, 'commandType', '')
            switch (statusPoint) {
            case 1:
              pointHistory.commandType = 1
              pointHistory.statusText = '獲得'
              break
            case 2:
              pointHistory.commandType = 2
              pointHistory.statusText = '利用'
              break
            case 3:
              pointHistory.commandType = 3
              pointHistory.statusText = '失効'
              break
            case 4:
              pointHistory.commandType = 4
              pointHistory.statusText = '取消'
              break
            default:
              break
            }
            pointHistory.date = this.formatDatePoint(_.get(content, 'historyDate', ''))
            this.listPointHistory.push(pointHistory)
          })
        }

      })
    },
    onChange1($event) {
      this.pagePointHistory = $event.pageNum  
      this.paramPointHistory.pointFrom = $event.pointFrom
      this.paramPointHistory.pointTo = $event.pointTo
      this.getListPointHistory(this.paramPointHistory)
    },
    gotoPath(index) {
      const query = this.$route.query
      switch (index) {
      case 1:
        this.$router.push({path: '/mypage/benepo-collect', query})
        break
      case 2:
        this.$router.push({path: 'bs-sch-01-001', query})
        break
      default:
        break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
